"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentScroll = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
;
const ContentScroll = (0, react_1.memo)((0, react_1.forwardRef)((_a, ref) => {
    var { style, active, onScroll } = _a, props = __rest(_a, ["style", "active", "onScroll"]);
    const scrollTop = (0, react_1.useRef)(true);
    const handleScroll = (0, react_1.useCallback)((e) => {
        const target = e.currentTarget;
        scrollTop.current = target.scrollTop === 0;
        if (typeof onScroll === 'function') {
            onScroll(e);
        }
    }, []);
    const handleMove = (0, react_1.useCallback)((e) => {
        if (active && !scrollTop.current) {
            e.stopPropagation();
        }
    }, [scrollTop, active]);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({}, props, { onTouchMove: handleMove, onScroll: handleScroll, style: Object.assign(Object.assign({}, style), { overflow: active ? 'auto' : 'hidden' }), ref: ref })));
}));
exports.ContentScroll = ContentScroll;
